import { render } from "./UpdateWebsiteModal.vue?vue&type=template&id=c334c8a6&scoped=true&ts=true"
import script from "./UpdateWebsiteModal.vue?vue&type=script&lang=ts"
export * from "./UpdateWebsiteModal.vue?vue&type=script&lang=ts"

import "./UpdateWebsiteModal.vue?vue&type=style&index=0&id=c334c8a6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c334c8a6"]])

export default __exports__